import "../Assets/Style/RoundTextLogo.css";
import ArrowImage from "../Assets/Images/Homepage/UpArrow.png";
import { useEffect, useRef, useState } from "react";
import { Box } from "@mui/material";

const AutoRoundTextLogo = () => {
  const text = "App Gallery • Building Intelligent Systems • ";
  const containerRef = useRef(null);
  const textRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsVisible(entry.isIntersecting);
      },
      { threshold: 0.3 }
    );

    if (containerRef.current) {
      observer.observe(containerRef.current);
    }

    return () => observer.disconnect();
  }, []);

  // 🔥 Auto rotation effect
  useEffect(() => {
    let animationFrameId;
    let rotation = 0;

    const animate = () => {
      if (isVisible && textRef.current) {
        rotation += 0.1; // speed (increase for faster rotation)
        textRef.current.style.transform = `rotate(${rotation}deg)`;
      }
      animationFrameId = requestAnimationFrame(animate);
    };

    animate();

    return () => cancelAnimationFrame(animationFrameId);
  }, [isVisible]);

  return (
    <Box display={{ xs: "none", md: "flex" }} className="logo-container" ref={containerRef}>
      <div className="circle-text" ref={textRef}>
        {text.split("").map((char, index) => (
          <span
            key={index}
            style={{
              transform: `rotate(${index * (360 / text.length)}deg)`,
            }}
          >
            {char}
          </span>
        ))}
      </div>

      <img src={ArrowImage} alt="center-arrow" className="center-image" />
    </Box>
  );
};

export default AutoRoundTextLogo;